import { LeadStatus, LeadDetermination } from '../types/lead.types';

// Canonical orderings for status and determination dropdowns. Reused across
// the leads list view, filters panel, detail modal, and bulk actions bar so
// labels and order stay consistent.
export const LEAD_STATUSES: LeadStatus[] = [
  'uncontacted',
  'cold',
  'warm',
  'hot',
  'enrolled',
  'lost',
  'dnc',
];

export const LEAD_DETERMINATIONS: LeadDetermination[] = [
  'pending',
  'valid',
  'invalid',
];

// Convert a LeadStatus enum value into a human-readable label.
export const getStatusLabel = (status: LeadStatus | string): string => {
  if (status === 'dnc') return 'Do Not Contact';
  return status.charAt(0).toUpperCase() + status.slice(1);
};

// Convert a LeadDetermination enum value into a human-readable label.
export const getDeterminationLabel = (det: LeadDetermination | string): string => {
  return det.charAt(0).toUpperCase() + det.slice(1);
};
